<template>
  <router-link :target="target" :to="href" class="information-box__link">
    <icon link class="information-box__link-icon" type="angle-right"></icon>
    <span class="information-box__link-text">
      <slot name="link"></slot>
    </span>
  </router-link>
</template>

<script>
import Icon from '@/components/Icon'

export default {
  name: 'af-link',

  components: {
    Icon
  },

  props: {
    href: {
      required: true,
      type: String
    },
    target: {
      default: '_self',
      type: String
    }
  }
}
</script>

<style lang="postcss" scoped>
.information-box__link {
  align-items: center;
  display: flex;
  font-weight: 400;
  text-decoration: none;
}

.information-box__link-icon {
  margin-right: 10px;
  text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/components/AfLink.vue